import React from 'react';

import i18n from '../../i18n';
import { useTranslation } from 'next-i18next';
import PropTypes from 'prop-types';
import styles from './Breadcrumbs.module.scss';
import Icon from '../../components/Icon';

const ConditionalWrapper = ({ condition, wrapper, children }) =>
    condition ? wrapper(children) : children;

const Breadcrumbs = ({ links = [] }) => {
    const { t } = useTranslation();

    return (
        !!links.length && (
            <div className={styles['Breadcrumbs']}>
                <nav
                    aria-label={t('generic.breadcrumbs')}
                    className={styles['Breadcrumbs__Nav']}>
                    <span className="sr-only">
                        {t('generic.breadcrumbs') + ': '}
                    </span>
                    <ol className={styles['Breadcrumbs__List']}>
                        {links.map((link, idx, arr) => (
                            <li
                                className={styles['Breadcrumbs__Item']}
                                key={idx}>
                                {idx !== 0 && <Icon type="chevron" size="xs" />}

                                <ConditionalWrapper
                                    condition={arr.length !== idx + 1}
                                    wrapper={(children) => (
                                        <a
                                            href={link.href}
                                            {...(arr.length === idx + 1
                                                ? { 'aria-current': 'page' }
                                                : {})}
                                            className={
                                                styles['Breadcrumbs__Link']
                                            }>
                                            {children}
                                        </a>
                                    )}>
                                    <span
                                        className={
                                            styles['Breadcrumbs__LinkText']
                                        }>
                                        {link.label}
                                    </span>
                                </ConditionalWrapper>
                            </li>
                        ))}
                    </ol>
                </nav>
            </div>
        )
    );
};

Breadcrumbs.propTypes = {
    links: PropTypes.array,
};

export default Breadcrumbs;
